module.exports = __webpack_public_path__ + "img/adjust_home_icon1.10f797f1.png";